module.exports = __webpack_public_path__ + "img/VAWS_Infographic.8de0e9ed.svg";